/* Copyright (c) 2017 Backpack Health LLC */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import RouteNames from '../../../appAuthorized/RouteNames';
import { isMobileApplication } from '../../../../utilities/MobileUtil';
import FileModel from '../../../../models/FileModel';
import FileActions from '../../../appAuthorized/redux/FileActions';
import AddMenuPhrases from '../../../../phraseKeys/AddMenu.phrase';
import FilePickerRow from './FilePickerRow';
import { MobileFileMenuChoices } from './AddMenuMobileFiles';
import AddMenu from './AddMenu';

import { useUIState } from '../../../hooks/useUIState';
import { useNavigate } from '../../../hooks/useNavigate';
import { useActiveProfile } from '../../../hooks/useProfile';

const AddMenuAttachments = (props) => {
  const { attachmentType, parentId } = props;

  const [{ isMainProfile }, uiActions] = useUIState();
  const [, navActions] = useNavigate();
  const [{ greetingName }] = useActiveProfile();

  const backpackChoice = AddMenuPhrases.sourceMenu.backpackChoice(isMainProfile, greetingName);
  const fileUploadRoute = RouteNames.fileUpload(attachmentType, parentId);

  return (
    <AddMenu>
      <div
        className="add-item font-color-profile-accent"
        onClick={() => {
          uiActions.dismissModal();
          navActions.replace(RouteNames.myBackpackSelectionFiles(attachmentType, parentId));
        }}
      >
        <div>
          <FormattedMessage {...backpackChoice}/>
        </div>
      </div>
      {
        isMobileApplication()
          ? (
            <MobileFileMenuChoices
              successRoute={fileUploadRoute}
              onCancel={() => {
                uiActions.dismissModal();
              }}
            />
          ) : (
            <FilePickerRow
              name="sourceFile"
              onChange={(rawFile) => {
                const newFile = FileModel.createFromRawFile(rawFile);

                if (newFile.isTooBig()) {
                  navActions.goTo(RouteNames.fileUploadError());
                } else {
                  FileActions.rawFileSelected(rawFile);
                  navActions.goTo(fileUploadRoute);
                }
                uiActions.dismissModal();
              }}
            >
              <div className="add-item font-color-profile-accent">
                <div>
                  <FormattedMessage id="list.fileSource.computer.name"/>
                </div>
              </div>
            </FilePickerRow>
          )
      }
    </AddMenu>
  );
};

export default AddMenuAttachments;
